// extracted by mini-css-extract-plugin
export default {"header":"Header_header__PqUH9","headerLeft":"Header_headerLeft__1GpNK","title":"Header_title__gA8PF","note":"Header_note__F4Lhd","headerRight":"Header_headerRight__aIu5B"};